import StatCard from "../../components/micheal/StatCard";
import MyCalendar from "../../components/micheal/MyCalendar";
import TimeTracker from "../../components/micheal/TimeTracker";
import Todo from "../../components/micheal/Todo";

function DashboardM() {
  return (
    <div className="container-fluid">

      <div className="row g-3">

        <div className="col-md-4">
          <StatCard title="Total Employees" value="18" />
        </div>

        <div className="col-md-4">
          <StatCard title="Job Open" value="15" />
        </div>

        <div className="col-md-4">
          <StatCard title="Total Project" value="10" />
        </div>

        <div className="col-md-4">
          <div className="card p-4 shadow "> <h3>Holidays & Leaves </h3>
          <div className="">
            <div className="card p-2 shadow text-info ">
              <p> Personel Holidays <br></br>10</p>
              </div>
              <div className="card p-2 shadow text-info">
              <p>National Holidays <br></br>12</p>
              </div>
              <div className="card p-2 shadow text-info">
              <p>Componsation Holidays <br></br>04</p>
              </div>
              <div className="card p-2 shadow text-info">
              <p>Total holidays <br></br>28</p>
              </div>
              </div>
          </div>
        </div>

        <div className="col-md-4">
          <TimeTracker />
        </div>

        <div className="col-md-4">
          <MyCalendar />
        </div>

        <div className="col-md-4">
          <Todo />
        </div>

        <div className="col-md-4">
          <div className="card p-4 shadow">Birthdays</div>
        </div>

        <div className="col-md-4">
          <div className="card p-4 shadow">Upcoming Holidays</div>
        </div>

        <div className="col-md-12">
          <div className="card p-4 shadow">Announcements</div>
        </div>

      </div>

    </div>
  );
}

export default DashboardM;